import { ReactNode, useMemo } from "react"
import { useSelector } from "react-redux"

import { ThemeProvider } from "@mui/material/styles"
import { RootState } from "../store"
import { BankEssential } from "../store/actions/bank"
import { CorporateEssential } from "../store/actions/corporates"
import { getCustomTheme } from "../theme"

const PaydoThemeProvider = ({ children }: { children: ReactNode }) => {
	const authBankUser: string | undefined = useSelector(
		(state: RootState) => state?.auth?.user?.idBank
	)
	const authCorporateUser: string | undefined = useSelector(
		(state: RootState) => state?.auth?.user?.corporateSenderId
	)
	const queryString = window.location.search
	const urlParams = new URLSearchParams(queryString)
	const theme = urlParams.get("theme")

	const bankUser: BankEssential | undefined = useSelector((state: RootState) =>
		state?.banksUser?.list.find(
			(el: BankEssential) => el.id === authBankUser || el.id === theme
		)
	)
	const corporateUser: CorporateEssential | undefined = useSelector(
		(state: RootState) =>
			state?.corporatesUser?.list.find(
				(el: CorporateEssential) =>
					el.id === authCorporateUser || el.id === theme
			)
	)

	const selectedTheme = useMemo(
		() => getCustomTheme(corporateUser || bankUser),
		[corporateUser, bankUser]
	)

	return (
		selectedTheme && (
			<ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>
		)
	)
}

export default PaydoThemeProvider
